// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-semibold[data-v-430aff50] {\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
